import {getUrlParams, setURLParams, slideDown, slideUp} from "../Utility/utils";
import PV from "../Utility/petite-vue";
import {InitializeHoverLists} from './media-list-hover-effect';
import {watchForPostLinkHover} from './media-block';
import {InitializeMediaBlockParallaxing} from '../Utility/init-gsap';
import {forceScrollSmootherUpdate, smoother, ScrollTrigger} from '../Utility/gsap';
import {listenForMediaLoad} from "./video";
import { updateLazyLoad } from "../Utility/lazy-loading";
import { InitializeContactForms } from "./contact-forms";

const PostListing = (data) => {
  const postsPerLoad = 9; // What is shown on initial load, and how much each "Load More" click should show.
  
  // Add postsRendered data to the posts data for easier syncing
  for(post in data.posts){
    data.posts[post].rendered = data.postsRendered[post];
    data.posts[post].renderedFull = data.postsRenderedFull[post];
    data.posts[post].renderedThinking = data.postsRenderedThinking[post];
  }

  // Ensure filter variable come through as array
  if(data.filters && typeof data.filters === 'object'){
    data.filters = Object.values(data.filters);
  }

  return {
    InitializeHoverLists,
    initialized:false,
    posts: data.posts,
    allFilteredResults : data.posts,
    postsLoaded: data.posts.slice(0,postsPerLoad),
    filters: data.filters,
    activeFilter: {
      slug: null,
      name: null,
    },
    showFilters: false,
    display: data.default_layout_style,
    lastDesktopDisplay: data.default_layout_style,
    displayLoadMore: false,
    post_type: data.post_types,
    default_breakpoint: 1367,
    mobile_breakpoint: null,
    block_element: null,
    filter_element: null,
    display_element: null,
    mobileFilterStyles: false,
    filtersVisible: true,
    isMobileLayout: false,
    windowWidth: null,
    updateExternalStuff(){
      InitializeHoverLists();
      listenForMediaLoad();
      updateLazyLoad();
      watchForPostLinkHover();
      InitializeMediaBlockParallaxing();
      InitializeContactForms();
    },
    mounted() {
      this.initialized = true;

      this.windowWidth = window.innerWidth;

      this.$nextTick( () => {
        this.block_element = document.querySelector('#' + data.blockID);

        this.updateExternalStuff();

        this.setMobileBreakpoint();
        this.checkIfMobile();
        this.eventListeners();
        this.setMobileFilterStyles();
        this.setFilterAriaHidden();
      } );
    },
    toggleDisplay(display){
      this.display = display;
      this.lastDesktopDisplay = display;
    },
    checkIfMobile() {
      this.isMobileLayout = this.windowWidth < this.default_breakpoint || this.windowWidth < this.mobile_breakpoint ? true : false;
    },
    setMobileBreakpoint() {
      // Set mobile breakpoint based on filter terms width
      const displayToggles = this.block_element.querySelector('.post-listing__display');
      const filterToggles = this.block_element.querySelector('.post-listing__filters');

      this.filter_element = filterToggles;
      this.display_element = displayToggles;

      if(this.windowWidth > 990 && !this.mobile_breakpoint){
        const displayTogglesWidth = displayToggles ? displayToggles.getBoundingClientRect().width : 0;
        const filterTogglesWidth = filterToggles ? filterToggles.getBoundingClientRect().width : 0;
        const width = displayTogglesWidth + filterTogglesWidth + 30;
        this.mobile_breakpoint = Math.round(width);
        this.filtersVisible = true;
      }

      if(this.windowWidth < 991 || this.windowWidth < this.mobile_breakpoint){
        this.filtersVisible = false;
      }
    },
    loadMore() {
      const currentLoadedCount = this.postsLoaded.length;
      const totalCount = this.allFilteredResults.length;
      const newCount = (totalCount - postsPerLoad) > currentLoadedCount ? currentLoadedCount + postsPerLoad : totalCount;
      this.postsLoaded = this.allFilteredResults.slice(0, newCount);
      this.displayLoadMore = this.postsLoaded.length < this.allFilteredResults.length;

      this.$nextTick( () => {
        this.updateExternalStuff();
      });
    },
    get urlParameters(){
      const urlParams = getUrlParams();

      if(urlParams.filter && Array.isArray(this.filters)){
        this.filters.forEach(filter => {
          if(filter.slug == urlParams.filter){
            this.activeFilter = filter;
          }
        });
      }

      if(urlParams.display){
        this.display = urlParams.display;
      }

      this.filterPosts();
    },
    setURL(){
      // Update the URL used for sharing
      const urlParams = {
        'filter' : this.activeFilter.slug ? this.activeFilter.slug : false
      };

      setURLParams(urlParams);
    },
    get isGrid() {
      return this.display === "view-layout-grid";
    },
    filterPosts(filter = false){
      if(filter){
        let activeFilter = {...this.activeFilter};
        activeFilter.slug = filter.slug;
        activeFilter.name = filter.name;
        this.activeFilter = activeFilter;
      }

      let allFilteredResults = [...this.posts];

      if(this.activeFilter.slug){
        allFilteredResults = allFilteredResults.filter((post) => {
          let include = false;

          if(post.terms && post.terms.indexOf(this.activeFilter.slug) != -1){
            include = true;
          }

          return include;
        });
      }

      this.allFilteredResults = allFilteredResults;
      this.postsLoaded = allFilteredResults.slice(0,postsPerLoad);
      this.displayLoadMore = this.postsLoaded.length < this.allFilteredResults.length;
      this.setURL();
      this.toggleMobileFiltersDisplay();
      this.$nextTick( () => {
        this.updateExternalStuff();
      });
    },
    setMobileFilterStyles(){
      // Determine if mobile class should be added/removed from filter bar.
      if(this.mobile_breakpoint){
        if(this.windowWidth < this.mobile_breakpoint && !this.mobileFilterStyles){
          this.mobileFilterStyles = true;
        }
        else if(this.windowWidth >= this.mobile_breakpoint && this.mobileFilterStyles){
          this.mobileFilterStyles = false;
        }
      }
    },
    setFilterAriaHidden(){
      // Determine aria-hidden attribute for filter bar
      if(this.isMobileLayout || this.showFilters) {
        this.filtersVisible = true;
      }
      else {
        this.filtersVisible = false;
      }
    },
    toggleMobileFiltersDisplay(){
      if(this.filter_element && this.isMobileLayout){
        this.showFilters = !this.showFilters;

        if(this.showFilters){
          slideDown(this.filter_element);
        }
        else {
          slideUp(this.filter_element);
        }

        setTimeout(()=>{
          this.filter_element.style.removeProperty('display');
        }, 501);

        this.setMobileFilterStyles();
        this.setFilterAriaHidden();
      }
    },
    eventListeners(){
      const windowResizeEvents = () => {
        this.windowWidth = window.innerWidth;
        this.checkIfMobile();
        this.setMobileFilterStyles();
        this.setFilterAriaHidden();

        // set layout to grid on mobile view
        if(this.isMobileLayout && this.display !== 'view-layout-grid'){
          this.lastDesktopDisplay = this.display;
          this.display = 'view-layout-grid';
        }
        if(!this.isMobileLayout && this.display !== this.lastDesktopDisplay){
          this.display = this.lastDesktopDisplay;
        }
      }

      if(this.filter_element){
        window.removeEventListener('resize', windowResizeEvents);
        window.addEventListener('resize', windowResizeEvents);
      }
    }
  }
}

PV.registerScope( "PostListing", PostListing );


const InitializePostListing = () => {
  PV.registerScope( "PostListing", PostListing );
}

export {
  InitializePostListing
}
